import React, { useEffect, useState } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Card } from 'reactstrap';
import { CardBody } from 'reactstrap';

import { withRouter } from 'react-router-dom';

const ShortLinks = (props) => {

  const { user } = useSelector((state) => state.Login);
  const { language } = useSelector(state => state.Languages);

  const [data, setData] = useState([
    {
      title: "Payouts",
      icon: <i className="bx bx-dollar-circle" style={{ fontSize: "40px" }}></i>,
      url: `/${language}/balance/payouts`,
      color: "success",
    },
    {
      title: "Instant Payments",
      icon: <i className="bx bx-link" style={{ fontSize: "40px" }}></i>,
      url: `/${language}/instant-payment`,
      color: "warning",
    },
    {
      title: "All Transactions",
      icon: <i className="bx bx-transfer-alt" style={{ fontSize: "40px" }}></i>,
      url: `/${language}/all-transactions`,
      color: "info",
    },
    {
      title: "Wallets",
      icon: <i className="bx bx-wallet-alt" style={{ fontSize: "40px" }}></i>,
      url: `/${language}/balance/wallets`,
      color: "primary",
    },
  ]);

  const drawStepLine = (item) => {
    if (!item) { return false; }
    return <div
      className={`step-line-item step-line-item-short-link text-white bg-${item.color} rounded w-100 py-4`}
      onClick={() => props.history.push(item.url)}
    >
      <div>
        {item.icon}
      </div>
      <div className='d-none d-md-block'>
        <span>{item.title}</span>
      </div>
    </div>
  }

  return (
    <Card>
      <CardBody>
        <div className='step-line'>
          <div className='d-flex gap-3 align-items-center'>
            <h5 className="m-0">Short Links</h5>
          </div>

          <hr />
          <div className='d-flex justify-content-evenly gap-3'>
            {
              data.map((item, index) => {
                return <div key={index} className='w-100' style={{ maxWidth: "300px" }}>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="bottom"
                    delay={{ show: 1, hide: 1 }}
                    overlay={<Tooltip id="button-tooltip">
                      <p className='mb-1'>{item.title}</p>
                    </Tooltip>}
                  >
                    {drawStepLine(item)}
                  </OverlayTrigger>
                </div>
              })
            }
          </div>

        </div>
      </CardBody>
    </Card>
  )
}

export default withRouter(ShortLinks)